import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDUIResponsiveContent } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIResponsiveContent";
import { SDUIBackgroundIcon } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/BackgroundIcon/SDUIBackgroundIcon";
import * as gridStyles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/styles.css";
import { SDUITypographyRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
export var SDUIGridHeaderRow = function(param) {
    var title = param.title, responsiveTitle = param.responsiveTitle, backgroundIcon = param.backgroundIcon, responsiveBackgroundIcon = param.responsiveBackgroundIcon, loggingData = param.loggingData;
    if (!title && !responsiveTitle) {
        return;
    }
    return /*#__PURE__*/ _jsxs(Row, {
        className: gridStyles.gridHeaderRow,
        children: [
            /*#__PURE__*/ _jsx(SDUIResponsiveContent, {
                defaultValue: title,
                serverResponsiveValues: responsiveTitle,
                convertValueToReactElement: convertTextElementToGridTitle(loggingData)
            }),
            /*#__PURE__*/ _jsx(SDUIBackgroundIcon, {
                backgroundIcon: backgroundIcon,
                responsiveBackgroundIcon: responsiveBackgroundIcon
            })
        ]
    });
};
var convertTextElementToGridTitle = function(loggingData) {
    return function convertTextElementToGridTitle(textElement) {
        return textElement ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
            textElement: textElement,
            loggingData: loggingData
        }) : null;
    };
};
